import {CartItemBuilder} from 'components/common/CartItemBuilder/CartItemBuilder'
import {DEFAULT_CART_ITEM} from 'components/common/CartItemBuilder/providers/InputProvider/consts'
import {ErrorMessage} from 'components/common/ErrorMessage'
import {FixedFooter} from 'components/common/FixedFooter'
import {Button} from 'components/system/Button'
import {Frame} from 'components/system/Frame'
import {Page} from 'components/system/Page'
import {useNextStepperPath} from 'hooks/useNextStepperPath'
import {useOrderActivityDetails} from 'hooks/useOrderActivityDetails'
import {useOrderOfferCombinations} from 'hooks/useOrderOfferCombinations'
import {useOrderQuestions} from 'hooks/useOrderQuestions'
import {usePreviousStepperPath} from 'hooks/usePreviousStepperPath'
import {useGetProductsQuery} from 'hooks/ventrata/useGetProductsQuery'
import {useActivityPath, useMoreToursPath} from 'providers/EnvironmentProvider'
import {useCallback, useState} from 'react'
import {v4 as uuid} from 'uuid'
import {areRequiredFieldsFilled} from '../Activity/utils/areRequiredFieldsFilled'
import {ProductCard} from './ProductCard/ProductCard'
import {TourCard} from './TourCard'

export const MoreTours = () => {
  const orderOfferCombinations = useOrderOfferCombinations()
  const getProductsQuery = useGetProductsQuery(orderOfferCombinations)
  const moreToursPath = useMoreToursPath()
  const nextPath = useNextStepperPath(moreToursPath)
  const previousPath = usePreviousStepperPath(moreToursPath)
  const [expaned, setExpanded] = useState(false)
  const orderQuestions = useOrderQuestions()
  const orderActivityDetails = useOrderActivityDetails()
  const requiredFieldsAreFilled = areRequiredFieldsFilled(orderQuestions, orderActivityDetails)
  const activityPath = useActivityPath()
  const [shownProductId, setShownProductId] = useState('')
  const [checkingProductId, setCheckingProductId] = useState('')

  const showBuilderPopup = useCallback((prodictId: string) => setCheckingProductId(prodictId), [])
  const hideBuilderPopup = useCallback(() => setCheckingProductId(''), [])

  const showProductPopup = useCallback((prodictId: string) => setShownProductId(prodictId), [])
  const hideProductPopup = useCallback(() => setShownProductId(''), [])

  const goToPayment = useCallback(() => {
    window.location.href = nextPath
  }, [nextPath])

  const returnToActivityPage = useCallback(() => {
    window.location.href = activityPath
  }, [activityPath])

  const back = useCallback(() => {
    window.location.href = previousPath
  }, [previousPath])

  const showMoreTours = useCallback(() => {
    setExpanded(true)
  }, [])

  if (getProductsQuery.error) {
    return <ErrorMessage error={getProductsQuery.error} />
  }

  return (
    <Page className="flex flex-col gap-4">
      <h3 className="font-bold text-[26px]">Explore more tours</h3>
      <div>Make your trip even better with these nearby tours</div>

      <Frame className="flex justify-between items-center p-4">
        <div className="basis-1/2">I don't want to add more tours</div>
        <Button.Primary.Orange onClick={goToPayment} className="!px-3 basis-1/2">
          Skip This Step
        </Button.Primary.Orange>
      </Frame>

      {!getProductsQuery.data && null}
      {getProductsQuery.data && (
        <>
          {!expaned && (
            <>
              {getProductsQuery.data.length > 3 && (
                <>
                  {getProductsQuery.data.slice(0, 3).map((product) => {
                    return (
                      <TourCard
                        key={product.id}
                        product={product}
                        onCheckAvailability={showBuilderPopup}
                        onShowDetails={showProductPopup}
                      />
                    )
                  })}

                  <Button.Secondary.Orange onClick={showMoreTours} expanded>
                    Show More Tours
                  </Button.Secondary.Orange>
                </>
              )}
              {getProductsQuery.data.length <= 3 &&
                getProductsQuery.data.map((product) => {
                  return (
                    <TourCard
                      key={product.id}
                      product={product}
                      onCheckAvailability={showBuilderPopup}
                      onShowDetails={showProductPopup}
                    />
                  )
                })}
            </>
          )}
          {expaned &&
            getProductsQuery.data.map((product) => {
              return (
                <TourCard
                  key={product.id}
                  product={product}
                  onCheckAvailability={showBuilderPopup}
                  onShowDetails={showProductPopup}
                />
              )
            })}

          <FixedFooter>
            <div className="flex gap-2">
              <Button.Back onClick={back} className="block d:hidden" />
              <Button.Primary.Orange onClick={requiredFieldsAreFilled ? goToPayment : returnToActivityPage} expanded>
                {requiredFieldsAreFilled ? 'Continue to Payment' : 'Complete activity details'}
              </Button.Primary.Orange>
            </div>
          </FixedFooter>
        </>
      )}
      {checkingProductId && (
        <CartItemBuilder
          onClose={hideBuilderPopup}
          initialState={{...DEFAULT_CART_ITEM, productId: checkingProductId, id: uuid()}}
          action="creatingMore"
          stepOrder="guestsFirst"
        />
      )}
      {shownProductId && (
        <ProductCard
          productId={shownProductId}
          onClose={hideProductPopup}
          onCheckAvailability={() => {
            hideProductPopup()
            showBuilderPopup(shownProductId)
          }}
        />
      )}
    </Page>
  )
}
